export default "__VITE_ASSET__6e70271c__"